import { gql } from "@apollo/client";
import FormSection from "controls/FormSection";
import MultiValuesField from "controls/MultiValuesField";
import useData from "hooks/useData";
import NumberInput from "inputs/NumberInput";
import SelectInput from "inputs/SelectInput";
import SwitchInput from "inputs/SwitchInput";
import TextInput from "inputs/TextInput";
import React from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";

export const VenuesFormFragment = gql`
  fragment VenuesFormFragment on Venue {
    id
    name
    city {
      id
    }
    details
    awsRegion
    encodingProcessingRegion
    maxConcurrentLiveStreams
    allowCameraPreview
  }
`;

export default function VenuesForm({ venues = [{}] }) {
  const [data] = useData(gql`
    query VenuesForm {
      outputGlAwsRegions {
        awsRegion
        name
      }
      encodingGlAwsRegions {
        awsRegion
        name
      }
    }
  `);
  // ensure fields default value align with database defaults
  venues = venues.map((venue) => ({
    maxConcurrentLiveStreams: 1,
    allowCameraPreview: true,
    ...venue,
  }));

  return (
    <>
      <MultiValuesField
        defaultValues={venues.map((v) => v.name)}
        required
        label="Name"
        name="name"
        input={<TextInput />}
        helperTextUiStringKey="readmin.venue.fields.name"
      />
      <MultiValuesField
        defaultValues={venues.map((v) => v.name)}
        label="Short Name"
        name="shortName"
        input={<TextInput />}
        helperTextUiStringKey="readmin.venue.fields.short_name"
      />
      <MultiValuesField
        defaultValues={venues.map((v) => v.city)}
        required
        label="City"
        name="city"
        input={<ReadminObjectInput optionsTypename="City" />}
        helperTextUiStringKey="readmin.venue.fields.city"
      />
      <MultiValuesField
        defaultValues={venues.map((v) => v.details)}
        label="Details"
        name="details"
        input={<TextInput multiline minRows={5} />}
        helperTextUiStringKey="readmin.venue.fields.details"
      />
      <FormSection header="AWS Regions Setting" defaultExpanded>
        <MultiValuesField
          defaultValues={venues.map((v) => v.awsRegion)}
          label="Video Storage Region"
          name="awsRegion"
          required
          input={
            <SelectInput
              options={data?.outputGlAwsRegions.map(({ name, awsRegion }) => ({ text: name, value: awsRegion }))}
            />
          }
          helperTextUiStringKey="readmin.venue.fields.aws_region"
        />
        <div style={{ marginTop: 5 }} />
        <MultiValuesField
          defaultValues={venues.map((v) => v.encodingProcessingRegion)}
          label="Encoding Processing Region"
          name="encodingProcessingRegion"
          input={
            <SelectInput
              options={data?.encodingGlAwsRegions.map(({ name, awsRegion }) => ({ text: name, value: awsRegion }))}
            />
          }
          helperTextUiStringKey="readmin.venue.fields.encoding_processing_region"
        />
      </FormSection>
      <MultiValuesField
        defaultValues={venues.map((v) => v.maxConcurrentLiveStreams)}
        label="Max Concurrent Live Streams"
        name="maxConcurrentLiveStreams"
        required
        input={<NumberInput min={0} />}
        helperTextUiStringKey="readmin.venue.fields.max_concurrent_live_streams"
      />
      <MultiValuesField
        defaultValues={venues.map((v) => v.allowCameraPreview)}
        label="Allow Camera Preview"
        name="allowCameraPreview"
        input={<SwitchInput />}
        helperTextUiStringKey="readmin.venue.fields.allow_camera_preview"
      />
    </>
  );
}
